const rankings = [
  {
    rank: 1,
    title: '斗破苍穹',
    category: '玄幻修仙',
    status: '连载中',
    heat: '本周人气 1280万',
    change: 'up',
    trend: '↑ 2',
    highlight: true,
  },
  {
    rank: 2,
    title: '海贼王',
    category: '热血冒险',
    status: '连载中',
    heat: '本周人气 1150万',
    change: 'down',
    trend: '↓ 1',
    highlight: false,
  },
  {
    rank: 3,
    title: '一人之下',
    category: '都市异能',
    status: '连载中',
    heat: '本周人气 980万',
    change: 'up',
    trend: '↑ 3',
    highlight: false,
  },
  {
    rank: 4,
    title: '咒术回战',
    category: '奇幻战斗',
    status: '连载中',
    heat: '本周人气 890万',
    change: 'same',
    trend: '— 0',
    highlight: false,
  },
  {
    rank: 5,
    title: '狐妖小红娘',
    category: '古风仙侠',
    status: '连载中',
    heat: '本周人气 760万',
    change: 'up',
    trend: '↑ 1',
    highlight: false,
  },
  {
    rank: 6,
    title: '女神降临',
    category: '恋爱校园',
    status: '已完结',
    heat: '本周人气 650万',
    change: 'down',
    trend: '↓ 2',
    highlight: false,
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫画人气排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            九妖漫画网实时人气排行，看看大家都在追哪些热门漫画
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 rounded-xl cursor-pointer transition-colors ${
                item.highlight
                  ? 'bg-primary-50/70 hover:bg-primary-100/60'
                  : 'hover:bg-background-100'
              }`}
            >
              {/* Rank Number */}
              <div className="flex-shrink-0 w-8 text-center">
                <span className={`font-heading font-black text-lg ${
                  item.rank === 1
                    ? 'text-primary-500'
                    : item.rank === 2
                    ? 'text-accent-500'
                    : item.rank === 3
                    ? 'text-secondary-500'
                    : 'text-foreground-400'
                }`}>
                  {item.rank.toString().padStart(2, '0')}
                </span>
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold text-sm md:text-base text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className={`px-1.5 py-0.5 text-xs rounded font-medium whitespace-nowrap flex-shrink-0 ${
                    item.status === '连载中'
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.status}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {item.category}
                </p>
              </div>

              {/* Heat & Trend */}
              <div className="flex-shrink-0 text-right">
                <p className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</p>
                <p className={`text-xs font-medium whitespace-nowrap ${
                  item.change === 'up'
                    ? 'text-primary-500'
                    : item.change === 'down'
                    ? 'text-foreground-400'
                    : 'text-foreground-400'
                }`}>
                  {item.trend}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}